import React from 'react'
import PropTypes from 'prop-types'

const CipherContainer = ({name, bgColor, description, onClick}) => {
  return (
      <div className='container'>
        <div className='container-bg' style={{ backgroundColor: bgColor }}></div>
        <h1 style={{zIndex: 2}}>{name}</h1>
        <p className='container-desc' >{description}</p>
        <button className='btn' onClick={onClick}><p className='btn-txt'>Learn</p></button>
    </div>
  )
}

CipherContainer.propTypes = {
    name: PropTypes.string,
}

export default CipherContainer